import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-white min-height" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "made-l-grid--fixed full-height-page" }, [
      _createElementVNode("div", { class: "made-l-grid" }, [
        _createElementVNode("div", { class: "made-l-grid__row" }, [
          _createElementVNode("p", null, "Health works!")
        ])
      ])
    ], -1)
  ])))
}